import { tss } from "@app/components/tss/tss";

import {
  CONTENT_PADDING_TOP,
  CONTENT_PADDING_BOTTOM,
  CONTENT_PADDING_X
} from "./seat-selection-bottom-section.styles";

export const useStyles = tss.create(({ theme }) => {
  const { spacing } = theme.busbud;

  return {
    root: {
      padding: spacing(
        CONTENT_PADDING_TOP,
        CONTENT_PADDING_X,
        CONTENT_PADDING_BOTTOM
      )
    }
  };
});
